<template>
</template>
<script>
import axios from 'axios';

const httpClient = axios.create({
    baseURL: window.location.origin,
    timeout: 30000,
});

export default {
    name: 'CsrfTokenGenerator',
    props: {
        formHandle: {
            type: String,
            required: true
        },
    },
    data: () => ({
        value: null,
        enabledBlitz: null
    }),
    created() {
        this.findBlitz(document)
    },
    mounted() {
        document.addEventListener('freeform-ready', (event) => {

            if (this.enabledBlitz) {
                this.updateCSRF(event.form)
            }
        })
    },
    methods: {
        updateCSRF(form) {
            httpClient.get(`/dynamic/token?form=${this.formHandle}`)
                .then(response => {
                    let tokenObject = response.data
                    form.querySelector('input[name=formHash]').value = tokenObject.hash

                    // Locate and update the CSRF input
                    let csrf = tokenObject.csrf
                    form.querySelector(`input[name=${csrf.name}]`).value = csrf.value
                })
        },
        findBlitz(rootElem) {
            const nodeIterator = document.createNodeIterator(
                rootElem,
                NodeFilter.SHOW_COMMENT,
            )

            let comments = []
            let curNode
            while (curNode = nodeIterator.nextNode()) {
                comments.push(curNode.nodeValue)
            }

            this.enabledBlitz = comments.filter(element => element.includes('Blitz')).length > 0;
        }
    },
}
</script>
